import {OETarget} from '../../../react-oe/oe-target';
import {OELicensingEdition} from '../../../react-oe/oe-types';
import {OEVersionFeatureAccess, OEVersionTargetsAlphaBetaProds, OEVersionStartSelectionDataAlphaBetaProd} from '../oe-proto-model';
import {OEEarTargetType as OEEarTargetType_, OEEarStartSelectionContent} from './oe-ear-consts';

export const OEEarTargetType = OEEarTargetType_;

export const OEEarTargets = new OEVersionTargetsAlphaBetaProds(
    {
        [OEEarTargetType.anatomy]: [
            OETarget.humanEarMacro,
            OETarget.humanEarInner,
            OETarget.humanEarMicro,
            OETarget.sensorySystems
        ]
    },
    {
        [OEEarTargetType.anatomy]: OETarget.humanEarMacro,
    },
    {
        [OEEarTargetType.anatomy]: OETarget.humanEarMacro,
    }
);

export const OEEarFeatureAccess = new(class extends OEVersionFeatureAccess {

    constructor(versionTargets) {
        super(versionTargets);
    }

    initialFeatureAccess()  {
        let isLicensing = this.isLicensing();
        return Object.assign(this.createFeatureAccessObj(), {
            anatomyTargetSelection: !isLicensing,
        });
    }

    featureAccessForLicensingAccess(licensingAccess)    {
        if(!licensingAccess.isLicensing)    return this.createFeatureAccessObj();

        let featureAccess = this.initialFeatureAccess();

        if(licensingAccess.isValid)    {
            if(OELicensingEdition.allAbove(OELicensingEdition.basic).includes(licensingAccess.edition))  {
                featureAccess.anatomyTargetSelection = true;
            }
        }

        return featureAccess;
    }
})(OEEarTargets);

export const OEEarStartSelectionData = new OEVersionStartSelectionDataAlphaBetaProd(
    OEEarTargets,
    OEEarStartSelectionContent
);